module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/placeholder/placeholder-04-ae28fce87b3ac1fb319bead93eb68bb5.jpg";